module.exports = __webpack_public_path__ + "img/article.f856cee6.png";